/*
 * ॐ नमः शिवाय
 * ಓಂ ನಮಃ ಶಿವಾಯ
 * ఓం నమః శివాయ
 * ஓம் நம சிவாய
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../theme/ThemeContext';
import '../styles/CountCard.css'

function CountCard({ icon, count, label, color }) {
    const { theme } = useTheme();

    return (
        <div
            className="count-card d-flex align-items-center p-3 shadow-sm"
            style={{
                minWidth: 220,
                background: '#fff',
                borderLeft: `5px solid ${color || theme.primary}`,
                borderRadius: theme.cardRadius
            }}
        >
            {/* Icon Left */}
            <div
                className="icon-wrapper d-flex align-items-center justify-content-center me-3"
                style={{
                    background: `${color || theme.primary}15`,
                    borderRadius: '50%',
                    width: 48,
                    height: 48
                }}
            >
                <i className={`bi ${icon} fs-2`} style={{ color: color || theme.primary }} />
            </div>
            {/* Count & Label */}
            <div className="d-flex flex-column flex-grow-1 text-start">
                <span style={{ fontWeight: 700, fontSize: 24, color: theme.primary }}>{count}</span>
                <span style={{ color: '#444', fontSize: 15 }}>{label}</span>
            </div>
        </div>
    );
}

export default CountCard;
